import {useMutation, gql} from '@apollo/client'

export const MUTATE_CREATE_CLIENT = gql`
  mutation MUTATE_CREATE_CLIENT($clientName: Customname!, $description: Alphanumeric) {
    createClient(clientName: $clientName, description: $description) {
      createClient {
        clientId
        clientName
        description
      }
    }
  }
`
export function useCreateClient() {
  return useMutation(MUTATE_CREATE_CLIENT, {
    context: {clientName: 'adminPanel'}
  })
}
